import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal } from "@/components/erp/ui";

export const fmtLogin = (l) => l ? `${new Date(l.at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" })}` : "Belum pernah";
const M = { google: "Google", password: "Password" };

export const LoginHistory = ({ acc, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/accounts/logins", { params: { email: acc.email } }).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [acc.email]);
  return (
    <Modal open onClose={onClose} title={`Riwayat Login — ${acc.name}`}>
      <div data-testid="login-history-list" className="space-y-2 max-h-[60vh] overflow-y-auto">
        {rows === null && <p className="text-sm text-slate-400">Memuat...</p>}
        {rows?.length === 0 && <p className="text-sm text-slate-400">Belum ada riwayat login.</p>}
        {rows?.map((r, i) => (
          <div key={i} className="border border-slate-100 rounded-lg px-3 py-2 text-sm">
            <div className="flex justify-between gap-2"><span className="font-medium">{fmtLogin(r)}</span><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100">{M[r.method] || r.method}</span></div>
            <div className="text-xs text-slate-500 mt-0.5">{r.location || "Lokasi tidak diketahui"} · IP {r.ip || "-"}</div>
            {r.ua && <div className="text-[11px] text-slate-400 truncate">{r.ua}</div>}
          </div>
        ))}
      </div>
    </Modal>
  );
};
